import { PodcastEntity } from '@/graphql/generated/graphql';
import { GAEvent } from './events';
import { pushDataLayer } from './utils';

type PodcastData = {
  podcast_id: string;
};

export const trackPodcastPlayed = async (podcast: Partial<PodcastEntity>) => {
  console.log('trackPodcastPlayed', podcast.id);

  const param = {
    podcast_id: podcast.id!,
  };

  pushDataLayer<PodcastData>(GAEvent.PODCAST_COMPLETED, param);
};
